<template>
  <div class="evaluate">
    <div class="info-row">
      <div style="float: left">
        <b>团队名称：</b>
        <el-select
          v-model="teamId"
          size="medium"
          placeholder="请选择团队"
          @change="getEvaluateInfo"
        >
          <el-option
            v-for="item in list"
            :key="item.teamId"
            :label="item.name"
            :value="item.teamId"
          >
          </el-option>
        </el-select>
        <b style="margin-left: 20px">队长姓名：</b>
        <span style="color: #409eff">{{ info.captainName }}</span>
      </div>

      <el-button
        class="submit-btn"
        type="primary"
        size="medium"
        @click="handleSubmit"
        >提交评分</el-button
      >
      <el-switch
        class="switch"
        v-model="info.mode"
        :active-value="2"
        :inactive-value="1"
        active-color="#13ce66"
        inactive-color="#409EFF"
        inactive-text="分项评分模式"
        active-text="总评分模式"
      >
      </el-switch>
    </div>

    <el-table
      class="list"
      :data="evaluateItemList"
      :span-method="objectSpanMethod"
      border
    >
      <el-table-column label="评价项目" prop="type" align="center" width="120">
      </el-table-column>
      <el-table-column label="评价分类" prop="question"> </el-table-column>
      <el-table-column label="分值" prop="qScore" align="center" width="80">
      </el-table-column>
      <!-- <el-table-column
        label="学生评分"
        prop="studentScore"
        width="80"
        align="center"
      >
      </el-table-column> -->
      <div v-if="info.mode == 1">
        <el-table-column prop="teacherScore" width="250" align="center">
          <template slot="header">
            <span>教师评分</span>
            <el-popover
              placement="top"
              trigger="hover"
              content="各评分选项分别取总分的百分比：好(100%)、良（80%）、中（70%）、及格（60%）、差（50%）"
            >
              <i
                class="el-icon-question"
                slot="reference"
                style="margin-left: 5px; color: #909399"
              ></i>
            </el-popover>
          </template>
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.teacherScore" size="small">
              <el-radio-button label="好"></el-radio-button>
              <el-radio-button label="良"></el-radio-button>
              <el-radio-button label="中"></el-radio-button>
              <el-radio-button label="及格"></el-radio-button>
              <el-radio-button label="差"></el-radio-button>
            </el-radio-group>
          </template>
        </el-table-column>
        <el-table-column prop="enterpriseScore" width="250" align="center">
          <template slot="header">
            <span>企业导师评分</span>
            <el-popover
              placement="top"
              trigger="hover"
              content="各评分选项分别取总分的百分比：好(100%)、良（80%）、中（70%）、及格（60%）、差（50%）"
            >
              <i
                class="el-icon-question"
                slot="reference"
                style="margin-left: 5px; color: #909399"
              ></i>
            </el-popover>
          </template>
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.enterpriseScore" size="small">
              <el-radio-button label="好"></el-radio-button>
              <el-radio-button label="良"></el-radio-button>
              <el-radio-button label="中"></el-radio-button>
              <el-radio-button label="及格"></el-radio-button>
              <el-radio-button label="差"></el-radio-button>
            </el-radio-group>
          </template>
        </el-table-column>
      </div>
      <el-table-column
        v-if="info.mode == 2"
        prop="score"
        label="自定义总评分"
        width="160"
        align="center"
      >
        <template>
          <el-input-number
            v-model="info.score"
            size="small"
            :min="0"
            :max="100"
          ></el-input-number>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { teamList } from "@/api/team";
import { evaluateInfo, doEvaluate } from "@/api/projectPractice/common";
import template from "./roadshow/template.vue";

export default {
  components: { template },
  props: {
    category: String,
  },
  data() {
    return {
      teamId: null,
      list: [],
      info: {},
      idArr: [],
      idPos: 0,
    };
  },
  computed: {
    evaluateItemList() {
      if (this.info.questionList) return this.info.questionList;
    },
  },
  methods: {
    // 团队列表
    getList() {
      teamList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
          if (this.list) this.teamId = this.list[0].teamId;

          this.getEvaluateInfo();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 评分详情
    getEvaluateInfo() {
      this.$loading.show();
      evaluateInfo(this.category, this.teamId).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.info = res.data;
          this.totalScore = res.data.questionList[0].score;
          this.formatSpan();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    formatSpan() {
      this.idArr = [];
      this.idPos = 0;
      this.evaluateItemList.forEach((item, i) => {
        if (i == 0) {
          // 第一行显示
          this.idArr.push(1);
          this.idPos = 0;
        } else {
          if (
            this.evaluateItemList[i].type == this.evaluateItemList[i - 1].type
          ) {
            // 相同则合并行数自加
            this.idArr[this.idPos] += 1;
            // 下一行不显示
            this.idArr.push(0);
          } else {
            // 不同则显示
            this.idArr.push(1);
            this.idPos = i;
          }
        }
      });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.idArr[rowIndex];
        // 判断当前的列是否需要显示
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (this.info.mode == 2) {
        if (columnIndex === 3) {
          return {
            rowspan: this.evaluateItemList.length,
            colspan: 1,
          };
        }
      }
    },
    handleSubmit() {
      let result = {};
      let check = this.evaluateItemList.some((item) => {
        return !item.enterpriseScore || !item.teacherScore;
      });
      this.evaluateItemList.forEach((item) => {
        result[item.itemId] = {
          enterpriseScore: item.enterpriseScore,
          teacherScore: item.teacherScore,
        };
      });

      if (this.info.mode == 1 && check) {
        this.$message.warning("请先完成评分");
        return;
      }
      this.$confirm("确定要提交评分吗?", {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          doEvaluate({
            category: this.category,
            teamId: this.teamId,
            score: this.info.score,
            mode: this.info.mode,
            itemScore: result,
          }).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("提交成功");
              this.getEvaluateInfo();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.evaluate {
  text-align: left;
  .info-row {
    margin-bottom: 10px;
    overflow: hidden;
    .submit-btn,
    .switch {
      float: right;
      &.switch {
        margin-right: 20px;
        height: 36px;
      }
    }
  }
  ::v-deep .list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
  }
}
</style>